<div class="chatContainer" [ngClass]="{'chatContainer--mobileList': displayListMobile}">
  <div class="chatContainer__list">
    <div class="chatContainer__list__header">
      <a routerLink="/" class="chatContainer__list__header__return">
        <vc-sprite-icons class="chatContainer__list__header__return__svg" name="cross-x"></vc-sprite-icons>
      </a>
      <span class="chatContainer__list__header__title" i18n="@@CHAT.LIST.MESSAGES">Messages</span>
    </div>
    <vc-notifications
      [isShow]="true"
      [showHeader]="false"
      [activableNotifications]="true"
      [channelId]="selectedChannelId"
      defaultCategory="messages"
      (displayListMobile)="displayListMobile = $event"
      (onClosePreviewBox)="closePreviewBox()"
    ></vc-notifications>
  </div>
  <vc-chat-discussion
    class="chatContainer__discussion"
    [channelId]="selectedChannelId"
    [openChatFromLike]="openChatFromLike"
    (displayListMobile)="displayListMobile = $event"
  ></vc-chat-discussion>
</div>
